import {CommonGrid} from './CommonGrid';

export default CommonGrid;
